/**
 * @file: socket
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2022-05-25 10:51:35
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-04-18 13:01:06
 * @FilePath: /console-znzs/src/utils/socket.js
 */
import WebSocket from '@/znzs/src/utils/websocket';
import {DIALOG_TYPE, DISPLAY_TYPE} from '@/znzs/src/utils/enum';
import {isTourist, isDev} from './env';

export default (sessionId, ctx) => {
    let host = location.host;
    if (isDev) {
        if (isTourist) {
            host = 'cloudtest.baidu.com';
        }
        else {
            host = 'qasandbox.bcetest.baidu.com';
        }
    }
    const config = {
        [isTourist]: `wss://${host}/api/znzs/ws/tourist/${sessionId}`,
        [!isTourist]: `wss://${host}/api/znzs/ws/customer/?sessionId=${sessionId}`,
    };
    // const config = {
    //     [isTourist]: `ws://bjyz-matrix-m12-x13-mixed-nuomi12.bjyz:8086/api/znzs/ws/customer/${sessionId}`,
    //     [!isTourist]: `ws://bjdd-acloud-sandbox-znzs00.bjdd:8086/api/znzs/ws/customer/${sessionId}`
    // };
    let socket = null;

    // 消息回执
    function sendAck(ackId, uniqueId) {
        if (socket) {
            socket.send({
                cmd: ackId,
                data: {
                    uniqueId,
                },
            });
        }
    }
    const options = {
        url: config.true,
        // 接收数据后回调
        onMessage: msg => {
            // cmd 7 用户侧返回的消息
            if (msg.cmd === 7) {
                sendAck(8, msg.uniqueId);
                if (ctx.state.chattingRecordsLists.find(v => v.dialogId === msg.data.dialogId)) { // 消息去重处理
                    return;
                }
                ctx.commit('setChatRecordsList', [msg.data]);
                ctx.dispatch('chat/cleanSingleMsg', msg.data.dialogId); // 单条消息已读

            }
        },
        oncloseFun: msg => {
            // 客服主动关闭请求，显示评价模块
            if (msg.cmd === 9) {
                sendAck(6, msg.uniqueId);
                ctx.commit('setChatRecordsList', [{
                    dialogId: -(new Date().getTime()),
                    dialogTime: Date.now(),
                    dialogType: DIALOG_TYPE.CUSTOMER_EVALUATE,
                    dialogInfo: {
                        display: DISPLAY_TYPE.CUSTOMER_EVALUATE,
                        evaluation: {
                            starRating: 0,
                        },
                    },
                }]);
            }
            ctx.commit('chat/clearSocket'); // 关闭socket
        },
    };

    socket = new WebSocket(options);
    return socket;
};
